import type { GasTopUpResult } from '../../hooks';
import type { GasEstimate } from '../../types';
import { TransactionDetailRow } from '../transaction-details/TransactionDetailRow';
import { GasNetworkCost } from '../transfers';

export type TransactionGasDetailRowProps = {
  gas:
    | {
        gasEstimate: GasEstimate | null;
        gasTopUpResult: GasTopUpResult | null;
      }
    | 'free';
};

export const TransactionGasDetailRow = ({
  gas,
}: TransactionGasDetailRowProps) => {
  return (
    <TransactionDetailRow
      label="Network fee"
      value={
        gas === 'free' ? (
          <div className="text-emphasis font-semibold">Free</div>
        ) : (
          <GasNetworkCost
            gasEstimate={gas.gasEstimate}
            gasTopUpResult={gas.gasTopUpResult}
          />
        )
      }
    />
  );
};
